import { render } from "./DatePicker.vue?vue&type=template&id=a033be56"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"
script.render = render

export default script